import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseService } from 'src/app/system-common/services/base.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { DocumentManagementService } from '../service/document-management.service';

@Component({
  selector: '',
  template: '',
})
export class DocumentManagementHandlerComponent
  extends BaseSearchComponent<DocumentManagementService>
  implements OnInit
{
  constructor(
    public service: DocumentManagementService,
    public headerService: HeaderService,
    public router: Router,
    public baseService: BaseService,
    public settingService: SettingService
  ) {
    super(service, router);
  }
  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Document',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Download',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Document';
    header.title = this.settingService.getLabelValue('document');
    return header;
  }

  protected Download_click(id) {
    let documentId = id.ref_id;

    this.service.getDocument(documentId).subscribe(
      (documentData) => {
        if (documentData != null) {
          let fileName = documentData['data']['fileName'];
          let fileContents = documentData['data']['fileContent'];
          let fileDataType = documentData['data']['fileDatatype'];

          if (fileName != null && fileContents != null && fileDataType != null) {
            this.viewFile(fileContents, fileName, fileDataType);
          } else {
            console.log('File Cannot be downloaded');
          }
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  viewFile(fileContents: string, fileName: string, fileDataType: string) {
    //  fileDataType = this.getFileDataType(fileName);
    // fileContents = fileContents.replace('data:' + fileDataType + ';base64,', '');
    const byteArray = new Uint8Array(
      atob(fileContents)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: fileDataType });
    let url = window.URL.createObjectURL(blob);
    // var winHeight = $(window).height() - 200;
    // var winWidth = $(window).width() - 600;
    // var windowOptions =
    //   'toolbar=0,location=0,directories=0,status=1,menubar=0,scrollbars=1,resizable=1,width=' +
    //   winWidth +
    //   ',height=' +
    //   winHeight +
    //   ',left=100,top=100';
    // window.open(url, 'win', windowOptions);
    var link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  }
}
